import _ from 'lodash'

const walkDownMixin = {
  walkDown(type, args) {
    return Promise.all(
      _.map(this.refs, (ref) => {
        if (ref.runWalk) {
          return ref.runWalk(type, args)
        }

        if (ref.walkDown) {
          return ref.walkDown(type, args)
        }
      })
    )
  },
}

export default walkDownMixin
